'use client';
import { createRef } from 'react';

import ScrollWithCarets from 'src/components/ScrollWithCarets';
import useCenteredCarousel from 'src/hooks/useCenteredCarousel';
import AuthorCard from 'src/components/AuthorCard';

type Props = {
    authors: any[];
};

export default function LocationAuthors({ authors }: Props) {
    const ulRef = createRef<HTMLUListElement>();
    useCenteredCarousel(ulRef);

    return (
        <ScrollWithCarets caretsClassName="top-1/4">
            <div className="container relative mx-auto h-[360px] overflow-visible">
                <ul ref={ulRef} className="md:pr-margin-semi-container absolute flex flex-nowrap gap-4 px-4 md:gap-8">
                    {authors.map((item) => (
                        <li data-carousel-item key={item.slug} className="w-56 snap-center bg-white">
                            <AuthorCard author={item} />
                        </li>
                    ))}
                </ul>
            </div>
        </ScrollWithCarets>
    );
}
